import React from 'react'
import './style.css'

export default function form_bg() {
    return (
          <div className="gambar_animated">
              <img src="asset/login/ass-paper.png" alt="paper" />
              <img src="asset/login/ass-paper.png" alt="paper" />
          </div>
    )
}
